import { configureStore } from '@reduxjs/toolkit';
import { agentApi } from './agent/api';
import { authSlice, setUser } from './auth';
import { authApi } from './auth/api';
import { propertyApi } from './realEstate/api';
import { IAuth } from './auth/interface';
import { SOJI_USER } from './constants';
import { hotelApi } from './hotel/api';
import { storeApi } from './shopping/api';
import { lifeStyleApi } from './lifeStyle/api';
import { dashboardApi } from './dashboard/api';
import { promotionApi } from './promotion/api';
import { adminApi } from './admin/api';
import axios from 'axios';

const result = localStorage.getItem(SOJI_USER);

export const store = configureStore({
  preloadedState: result
    ? {
        auth: JSON.parse(result) as IAuth
      }
    : undefined,
  reducer: {
    auth: authSlice.reducer,
    [authApi.reducerPath]: authApi.reducer,
    [agentApi.reducerPath]: agentApi.reducer,
    [propertyApi.reducerPath]: propertyApi.reducer,
    [hotelApi.reducerPath]: hotelApi.reducer,
    [storeApi.reducerPath]: storeApi.reducer,
    [lifeStyleApi.reducerPath]: lifeStyleApi.reducer,
    [dashboardApi.reducerPath]: dashboardApi.reducer,
    [promotionApi.reducerPath]: promotionApi.reducer,
    [adminApi.reducerPath]: adminApi.reducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false
    })
      .concat(authApi.middleware)
      .concat(agentApi.middleware)
      .concat(propertyApi.middleware)
      .concat(hotelApi.middleware)
      .concat(storeApi.middleware)
      .concat(lifeStyleApi.middleware)
      .concat(dashboardApi.middleware)
      .concat(promotionApi.middleware)
      .concat(adminApi.middleware)
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response && error?.response.status === 411) {
      store.dispatch(setUser(null));
    }
    return Promise.reject(error);
  }
);
